/**
 * Checks whether state code is Texas state code.
 *
 * @param {string} stateCode
 * @returns {boolean}
 */
export function isTexas(stateCode) {
  return stateCode === 'TX';
}
